import React from 'react';
import './App.css';

export const StatusComponent = ({ value, size }) => {

    const getStatusClass = (status) => {
        switch (status) {
            case 'NEW':
                return 'status-new';
            case 'TRUE':
                return 'status-true';
            case 'FALSE':
                return 'status-false';
            case 'CLOSED':
                return 'status-closed';
            default:
                return 'status-new';
        }
    };

    const getSizeClass = (size) => {
        switch (size) {
            case 'large':
                return 'status-large';
            default:
                return 'status-small';
        }
    };

    const statusClass = getStatusClass(value);
    const sizeClass = getSizeClass(size);
    
    return (
        <div className={`status-cell-wrapper`}>
            <div className={`status-cell ${sizeClass} ${statusClass}`}>{value}</div>
        </div>
    );
};
